const paramsSettings = {
    HR: {
        min: 30,
        max: 300
    },
    QT: {
        min: 200,
        max: 600
    },
    QRS: {
        min: 35,
        max: 350
    },
    PQ: {
        min: 45,
        max: 600
    },
    angles: {
        min: -180,
        max: 180
    },
    ST: {
        min_mV: -2, // мВ
        max_mV: 2
    },
    IndSokolLyon: {
        min_mV: -10, // мВ
        max_mV: 10
    }
};

export default paramsSettings;
